export default __webpack_public_path__ + "assets/models/aadfeca7764f9738a70ae20edebe0bbc.glb";